export function concat(target, source) {
    for(let i = 0; i < source.length; i++){
        target.push(source[i]);
    }
}

//# sourceMappingURL=concat.js.map